import { render, staticRenderFns } from "./HomeBranding.vue?vue&type=template&id=17f99c41"
import script from "./HomeBranding.vue?vue&type=script&lang=js"
export * from "./HomeBranding.vue?vue&type=script&lang=js"
import style0 from "./HomeBranding.vue?vue&type=style&index=0&id=17f99c41&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports